document.addEventListener('DOMContentLoaded', function() {
  const zipCheckerContainer = document.querySelector('.zip-checker.container');
  
  // Fetch settings from data attributes
  const deliveryAreas = zipCheckerContainer.getAttribute('data-zip-codes').toUpperCase().split(',').map(s => s.trim());
  const successMessage = zipCheckerContainer.getAttribute('data-success-message');
  const errorMessage = zipCheckerContainer.getAttribute('data-error-message');

  document.querySelector('.zip-checker button').addEventListener('click', function(event) {
    console.log('dwed');
    
    event.preventDefault();

    const postcode = document.querySelector('.zip-checker #postcode').value.toUpperCase();
    const resultDiv = document.querySelector('.zip-checker #result');
    const isDeliverable = deliveryAreas.some(area => postcode.startsWith(area));

    if (isDeliverable) {
      resultDiv.textContent = successMessage;
      resultDiv.className = 'success';
    } else {
      resultDiv.textContent = errorMessage;
      resultDiv.className = 'error';
    }

    // Show result with animation
    resultDiv.classList.add('visible')

  });
});
